$(document).ready(function () {
  if ($('.food-waste.prr-site-content').length) {
  $('.partners-slider').not('.slick-initialized').slick({
      slidesToShow: 4,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 700,
      responsive: [
          {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,

              }
          },{
              breakpoint: 768,
              settings: {
                autoplaySpeed: 1500,
                slidesToShow: 2,
              }
          },{
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
              }
          }
      ]
  });
  }
});
